import { Instagram, Mail, ArrowUp } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-12 border-b border-white/10">
          <div>
            <a
              href="#top"
              data-testid="footer-logo"
              className="font-display text-6xl sm:text-7xl md:text-8xl font-light tracking-tighter leading-none text-white block"
            >
              OUTTA<span className="italic font-medium">RAGE</span>
            </a>
            <p className="mt-4 max-w-md text-neutral-400 text-sm md:text-base">
              Creator management for internet-first talent. Built for creators worldwide.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
            <a
              href="https://instagram.com/outtarage"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/40 hover:bg-white/5 px-5 py-3 text-sm transition-colors"
            >
              <Instagram className="h-4 w-4" strokeWidth={1.5} />
              @outtarage
            </a>
            <a
              href="mailto:contact@outtarage.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/40 hover:bg-white/5 px-5 py-3 text-sm transition-colors"
            >
              <Mail className="h-4 w-4" strokeWidth={1.5} />
              contact@outtarage.com
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="text-xs uppercase tracking-[0.22em] text-neutral-500">
            © {new Date().getFullYear()} OuttaRage Management. All rights reserved.
          </div>

          <div className="flex items-center gap-6 text-xs uppercase tracking-[0.22em] text-neutral-500">
            <a href="#about" className="hover:text-white transition-colors">
              About
            </a>
            <a href="#services" className="hover:text-white transition-colors">
              Services
            </a>
            <a
              href="#top"
              data-testid="footer-back-to-top"
              className="inline-flex items-center gap-1.5 hover:text-white transition-colors"
            >
              Top
              <ArrowUp className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
